import React from 'react';
import _ from 'lodash';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';

import { Field, fieldArrayPropTypes } from 'redux-form';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import TextField from '../../../../components/statelessComponents/FormFields/TextField';
import Checkbox from '../../../../components/statelessComponents/FormFields/Checkbox';
import RadioGroup from '../../../../components/statelessComponents/FormFields/RadioGroup';
import s from './RenderAnswers.scss';
import {
  replaceDecimalsSeparatorToComma,
  replaceDecimalsSeparatorToDot,
} from '../../../../helpers/mathQuestions';

const messages = defineMessages({
  trueLabel: {
    id: 'EditQuestion.trueLabel',
    defaultMessage: 'True',
    description:
      'Label displayed in true or false questions edit question modal',
  },
  falseLabel: {
    id: 'EditQuestion.falseLabel',
    defaultMessage: 'False',
    description:
      'Label displayed in true or false questions edit question modal',
  },
  openQuestionPlaceholder: {
    id: 'EditQuestion.openQuestionPlaceholder',
    defaultMessage: 'Type your answer here…',
    description:
      'The text placeholder for open questions (basic math/fill in blank/reflection exercise)',
  },
});

const SYMBOLS_LENGTH = 70;

@injectIntl
@withStyles(s)
export default class RenderAnswers extends React.Component {
  static propTypes = {
    ...fieldArrayPropTypes,
    intl: intlShape.isRequired,
  };

  render() {
    const {
      fields,
      questionNumber,
      quiz,
      answeredQuestions,
      intl: { formatMessage },
      isAnswerSending,
    } = this.props;
    return (
      <div>
        {fields.map((field, index) => {
          const k = index;
          const question =
            _.find(quiz.questions, { _id: fields.get(index)._id }) || {};
          const currentQuestion =
            _.find(quiz.questions, { _id: fields.get(questionNumber)._id }) ||
            {};
          const isAnswered = _.find(
            answeredQuestions || [],
            item =>
              item.question === currentQuestion._id &&
              item.answer !== undefined,
          );

          return (
            <div key={k} data-question-type={question.type} data-no-translate>
              <Paper>
                {question.type === 'multiple choice' && (
                  <div
                    className={
                      questionNumber !== index ? s.hide : s.answersContainer
                    }
                  >
                    {question.generalAnswers.map((answer, i) => {
                      const key = i;
                      return (
                        <div
                          className={classNames(s.marginLeft, {
                            [s.noneVerticalPadding]:
                              answer.description.length < SYMBOLS_LENGTH,
                          })}
                          key={key}
                        >
                          <Field
                            name={`${field}.answers[${i}]`}
                            component={Checkbox}
                            color="primary"
                            disabled={
                              (quiz.quizMode === 'Check' &&
                                isAnswered &&
                                currentQuestion._id === isAnswered.question) ||
                              isAnswerSending
                            }
                            disableRipple
                            label={answer.description}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
                {question.type === 'single choice' && (
                  <div
                    className={
                      questionNumber !== index ? s.hide : s.answersContainer
                    }
                  >
                    {question.generalAnswers.map((answer, i) => {
                      const key = i;
                      return (
                        <Field
                          name={`${field}.answers`}
                          component={RadioGroup}
                          className={classNames(s.marginLeft, {
                            [s.noneVerticalPadding]:
                              answer.description.length < SYMBOLS_LENGTH, // length in one
                          })}
                        >
                          <FormControlLabel
                            value={answer.description}
                            control={<Radio color="primary" disableRipple />}
                            label={answer.description}
                            key={key}
                            disabled={
                              (quiz.quizMode === 'Check' &&
                                isAnswered &&
                                currentQuestion._id === isAnswered.question) ||
                              isAnswerSending
                            }
                          />
                        </Field>
                      );
                    })}
                  </div>
                )}
                {question.type === 'fill in blank' && (
                  <div
                    className={questionNumber !== index ? s.hide : s.smallField}
                  >
                    <Field
                      name={`${field}.answers`}
                      type="text"
                      component={TextField}
                      className={classNames(s.smallField)}
                      normalize={value => value.replace(/\s\s+/g, ' ')}
                      disabled={
                        (quiz.quizMode === 'Check' &&
                          isAnswered &&
                          currentQuestion._id === isAnswered.question) ||
                        isAnswerSending
                      }
                      placeholder={formatMessage(
                        messages.openQuestionPlaceholder,
                      )}
                    />
                  </div>
                )}
                {question.type === 'reflection exercise' && (
                  <div
                    className={
                      questionNumber !== index
                        ? s.hide
                        : classNames(s.smallField, s.fullWidth)
                    }
                  >
                    <Field
                      name={`${field}.answers`}
                      type="text"
                      component={TextField}
                      className={classNames(s.smallField, s.fullWidth)}
                      normalize={value => value.replace(/\s\s+/g, ' ')}
                      rows={6}
                      multiline
                      disabled={
                        (quiz.quizMode === 'Check' &&
                          isAnswered &&
                          currentQuestion._id === isAnswered.question) ||
                        isAnswerSending
                      }
                      placeholder={formatMessage(
                        messages.openQuestionPlaceholder,
                      )}
                    />
                  </div>
                )}
                {question.type === 'true or false' && (
                  <div
                    className={
                      questionNumber !== index ? s.hide : s.trueOrFalseField
                    }
                  >
                    <Field
                      name={`${field}.answers`}
                      component={RadioGroup}
                      disabled={
                        quiz.quizMode === 'Check' &&
                        isAnswered &&
                        currentQuestion._id === isAnswered.question
                      }
                      className={s.marginLeft}
                    >
                      <FormControlLabel
                        value="true"
                        control={<Radio color="primary" disableRipple />}
                        disabled={
                          (quiz.quizMode === 'Check' &&
                            isAnswered &&
                            currentQuestion._id === isAnswered.question) ||
                          isAnswerSending
                        }
                        label={formatMessage(messages.trueLabel)}
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio color="primary" disableRipple />}
                        disabled={
                          (quiz.quizMode === 'Check' &&
                            isAnswered &&
                            currentQuestion._id === isAnswered.question) ||
                          isAnswerSending
                        }
                        label={formatMessage(messages.falseLabel)}
                      />
                    </Field>
                  </div>
                )}
                {question.type === 'basic math' && (
                  <div
                    className={questionNumber !== index ? s.hide : s.smallField}
                  >
                    <Field
                      className={classNames(s.smallField)}
                      name={`${field}.answers`}
                      type="text"
                      onChange={this.clearMathQuestionTestResults}
                      // label={formatMessage(messages.nameLabel)}
                      normalize={(value, previousValue) =>
                        /^-?[0-9]*,?[0-9]*$/.test(value)
                          ? replaceDecimalsSeparatorToDot(value)
                          : previousValue
                      }
                      format={value => replaceDecimalsSeparatorToComma(value)}
                      component={TextField}
                      disabled={
                        (quiz.quizMode === 'Check' &&
                          isAnswered &&
                          currentQuestion._id === isAnswered.question) ||
                        isAnswerSending
                      }
                      fullWidth
                      placeholder={formatMessage(
                        messages.openQuestionPlaceholder,
                      )}
                    />
                  </div>
                )}
              </Paper>
            </div>
          );
        })}
      </div>
    );
  }
}
